import { Form as BootstrapForm } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

import FormField from "./FormField";
import FormFieldArray from "./FormFieldArray";
import PrimaryButton from "../PrimaryButton";

const Form = ({
  formDetails,
  onSubmit,
  form,
  additionalButtons = null,
  disabled = false,
}) => {
  return (
    formDetails && (
      <div className="text-center">
        {formDetails.label && (
          <h4 style={{ fontWeight: "500" }}>{formDetails.label}</h4>
        )}
        <form onSubmit={form.handleSubmit(onSubmit)} className="mt-1 mb-2">
          <Container>
            {formDetails.steps.map((field, index) => (
              <BootstrapForm.Group
                key={field.name}
                className={index !== 0 && "mt-3"}
              >
                {field.type === "array" ? (
                  <FormFieldArray field={field} form={form} />
                ) : (
                  <FormField field={field} form={form} />
                )}
              </BootstrapForm.Group>
            ))}
          </Container>
          {!disabled && (
            <Container className="text-center">
              <Row>
                <Col>
                  <PrimaryButton
                    type='submit'
                    className="mt-4 w-100"
                  >
                    {formDetails.submitButtonLabel}
                  </PrimaryButton>
                </Col>
                {additionalButtons && (
                  <Col>
                    <Container>{additionalButtons}</Container>
                  </Col>
                )}
              </Row>
            </Container>
          )}
        </form>
      </div>
    )
  );
};

export default Form;
